import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { HeartAnimation } from '../HeartAnimation';
interface Props {
  width?: number;
  height?: number;
  isActive?: boolean;
  onClick?: () => void;
}
const WishlistIcon = forwardRef<SVGSVGElement, Props>(({
  width = 40,
  height = 40,
  isActive,
  onClick
}, ref) => {
  const [localActive, setLocalActive] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const active = isActive !== undefined ? isActive : localActive;
  const prevActiveRef = useRef(active);
  const handleClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    const newActiveState = isActive !== undefined ? !isActive : !localActive;

    // Show animation only when transitioning from inactive to active
    if (!prevActiveRef.current && newActiveState) {
      setShowAnimation(true);
    }
    if (isActive === undefined) {
      setLocalActive(newActiveState);
    }
    onClick?.();
  };

  // Reset animation after it plays
  useEffect(() => {
    if (showAnimation) {
      const timer = setTimeout(() => {
        setShowAnimation(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [showAnimation]);

  // Update previous active state
  useEffect(() => {
    prevActiveRef.current = active;
  }, [active]);
  return <div style={{
    position: 'relative',
    display: 'inline-block',
    width: width,
    height: height
  }}>
        <svg width={width} height={height} viewBox="0 0 40 40" fill="none" ref={ref} onClick={handleClick} style={{
      cursor: 'pointer',
      transform: active ? 'scale(1.1)' : 'scale(1)',
      transition: 'transform 0.3s ease, fill 0.3s ease',
      position: 'relative',
      zIndex: 2
    }}>
          <rect width="39" height="39" x=".5" y=".5" rx="7.5" fill={active ? '' : '#fff'} stroke={active ? '' : '#E6EBF0'} strokeWidth="1" style={{
        transition: 'fill 0.3s ease, stroke 0.3s ease'
      }} />

          {active ? <path fill="#e05109" d="M1 9.459c0 5.367 4.421 8.227 7.658 10.787C9.8 21.15 10.9 22 12 22s2.2-.85 3.342-1.754C18.58 17.686 23 14.826 23 9.46S16.95.286 12 5.445C7.05.285 1 4.092 1 9.46" transform="translate(8 7.7)" style={{
        transition: 'fill 0.3s ease'
      }} /> : <path fill="#33393d" d="m12 6.011-.553.528a.77.77 0 0 0 1.106 0zM9.366 19.027c-1.55-1.213-3.247-2.397-4.592-3.9-1.319-1.474-2.24-3.193-2.24-5.424H1c0 2.706 1.136 4.77 2.626 6.435 1.464 1.635 3.33 2.943 4.79 4.085zM2.535 9.703c0-2.183 1.244-4.015 2.941-4.784 1.65-.748 3.865-.55 5.971 1.62l1.106-1.056c-2.499-2.575-5.4-3-7.715-1.95C2.57 4.563 1 6.95 1 9.704zm5.881 10.52c.524.41 1.087.847 1.657 1.178S11.293 22 12 22v-1.523c-.317 0-.69-.122-1.153-.39-.462-.27-.943-.639-1.48-1.06zm7.168 0c1.46-1.142 3.326-2.45 4.79-4.085C21.864 14.473 23 12.41 23 9.703h-1.535c0 2.23-.92 3.95-2.24 5.424-1.344 1.503-3.04 2.687-4.591 3.9zM23 9.703c0-2.753-1.57-5.141-3.838-6.17-2.316-1.05-5.216-.625-7.715 1.95l1.106 1.056c2.106-2.17 4.322-2.368 5.97-1.62 1.698.77 2.942 2.6 2.942 4.784zm-8.366 9.324c-.539.421-1.019.79-1.481 1.06-.463.268-.836.39-1.153.39V22c.707 0 1.357-.269 1.927-.6s1.133-.767 1.657-1.177z" transform="translate(8 7.7)" style={{
        transition: 'fill 0.3s ease'
      }} />}
        </svg>

        {showAnimation && <HeartAnimation isActive={active} />}
      </div>;
});
export default WishlistIcon;